<div class="container" *ngIf="caseData != null">

    <div class="hearingClass" *ngIf=" caseData.summary.status == 'SET_HEARING' && caseData.summary.current_form == 'TWOTHREE'">
        <mat-toolbar>
            <h4 class="hearingNotice">Sending Notice of Hearing</h4>
            <button style="margin-left: auto;" (click)="close()">
                <mat-icon style="color: white;margin-top: 5px;cursor: pointer;">close</mat-icon>
            </button>
        </mat-toolbar>
        <div class="" style="margin:30px;">
            <div class="">
                <p class="sendingNotice">Sending hearing notice to the heir and ward</p>
                <p class="heading"> Posting Mail on Date to People involved in case</p>
                <form #hearingForm="ngForm">

                    <mat-form-field class="example-full-width">
                        <mat-select placeholder="Hearing Date" aria-label="Number" [formControl]="myControl"
                            [(ngModel)]="hearingData.hearingDate" required>
                            <mat-option *ngFor="let monday of mondays" [value]="monday.dateValue">
                                {{monday.dateDisplayValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- <mat-form-field class="mailnotice">

                  <input matInput [matDatepickerFilter]="hearingDateFilter" [matDatepicker]="hearingDate" [min]="dateToday"
                    [(ngModel)]="hearingForm.hearingDate" name="hearingDate" placeholder="Hearing Date"
                    #hearingDateModel="ngModel" required>


                  <mat-datepicker-toggle matSuffix [for]="hearingDate"></mat-datepicker-toggle>

                  <mat-datepicker #hearingDate [startAt]="dateToday"></mat-datepicker>
                  <mat-error>
                    <span *ngIf="hearingDateModel.invalid" class="textColor"> Hearing Date required</span>
                  </mat-error>
                </mat-form-field> -->

                    <br />

                    <mat-form-field class="hours">
                        <mat-select [(ngModel)]="hearingData.hearingHour" name="hearingHour" placeholder="Hearing Hour"
                            #hearingHour="ngModel" required>
                            <mat-option *ngFor="let hour of hours" [value]="hour">
                                {{ hour }}
                            </mat-option>
                        </mat-select>
                        <mat-error>
                            <span *ngIf="hearingHour.invalid" class="textColor"> Date required</span>
                        </mat-error>
                    </mat-form-field>

                    :

                    <mat-form-field class="minutes">
                        <mat-select [(ngModel)]="hearingData.hearingMinute" name="hearingMinutes"
                            placeholder="Hearing Minute" #hearingMinutes="ngModel" required>
                            <mat-option *ngFor="let min of minutes" [value]="min">
                                {{ min }}
                            </mat-option>
                        </mat-select>
                        <mat-error>
                            <span *ngIf="hearingMinutes.invalid" class="textColor"> Minutes required</span>
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="minutes">
                        <mat-select [(ngModel)]="hearingData.hearingPartOfDay" name="hearingPartOfTheDay"
                            placeholder="part of day" #hearingPartOfTheDay="ngModel" required>
                            <mat-option [value]="'AM'">
                                am
                            </mat-option>
                            <mat-option [value]="'PM'">
                                pm
                            </mat-option>
                        </mat-select>
                        <mat-error>
                            <span *ngIf="hearingPartOfTheDay.invalid" class="textColor"> Day required</span>
                        </mat-error>
                    </mat-form-field>

                    <br />

                    <p class="heading">People Involved with this case:</p>

                    <div class="p-12">


                        <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.xs="row" class="people">

                            <div *ngFor="let contact of caseContacts;" class="w-50">

                                <div fxLayout="col" fxLayout.xs="column" class="people-left">
                                    <img class="avatar" src="assets/images/avatars/profile.jpg">
                                    <div class="pt-10p">
                                        <mat-hint class="name"> {{contact.name}} </mat-hint>
                                        <br />
                                        <mat-hint>{{contact.position}}</mat-hint>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <br />
                    <div style="padding-bottom: 25px;">
                        <button [class.loading]="loading" class="actionBtn" mat-raised-button color="accent"
                            class="pull-right actionButton" (click)="hearingSubmit(hearingData)"
                            [disabled]="hearingForm.invalid || loading" style="text-transform: uppercase">
                            <div class="spinner"></div>
                            <span class="label">Submit</span>
                        </button>
                        <!-- <button mat-raised-button color="warn" (click)="close()" class="actionBtn" style="text-transform: uppercase"
                    [disabled]="loading">Cancel</button>&nbsp;&nbsp; -->

                    </div>
                </form>
            </div>
        </div>



    </div>

    <div *ngIf=" caseData.summary.status == 'SET_JUDGEMENT'">

        <div style="text-align : center">
            <mat-toolbar style="padding-right: 5px;">
                <h4>JUDGEMENT</h4>
                <button style="margin-left: auto;margin-right: 10px;cursor: pointer;" (click)="close()">
                    <mat-icon style="color: white">close</mat-icon>
                </button>
            </mat-toolbar>
        </div>
        <div style="margin: 25px;font-size: 18px; text-align: center;">
            <div style="margin: 15px;">
                After reviewing the case, case has been
            </div>
            <div>
                <div>
                    <button mat-raised-button color="warn" (click)="caseDenied(true)"
                        [disabled]="loading">DENY</button>
                    <button mat-raised-button color="accent" [class.loading]="loading" [disabled]="loading"
                        class="" (click)="caseApproved(true)">
                        <div class="spinner"></div>
                        <span class="label">APPROVE</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div
        *ngIf="( userRole == 'CLERK' || userRole == 'JUDGE' ) && caseData.summary.current_form == 'TWOTHREE' && caseData.summary.status == 'FILED_FOR_JUDGE'">
        <mat-toolbar>
            <h4>Guardian AdLitem Appointed</h4>
        </mat-toolbar>
        <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value"
        [bufferValue]="bufferValue"></mat-progress-bar>
        <div style="text-align: center; padding:20px;">
            <form name="dateForm" (ngSubmit)="onNoClick()">

                <mat-form-field class="example-full-width">
                    <input matInput [(ngModel)]="caseForm.caseNumber" name="caseForm.caseNumber" disabled=true
                        placeholder="Case Number">
                </mat-form-field>

                <mat-form-field class="example-full-width">
                    <input matInput [(ngModel)]="guardianDetail.first_name" name="guardianDetail.first_name" disabled=true
                        placeholder="Guardian AdLitem First Name">
                </mat-form-field>

                <mat-form-field class="example-full-width">
                    <input matInput [(ngModel)]="guardianDetail.last_name" name="guardianDetail.last_name" disabled=true
                        placeholder="Guardian AdLitem Last Name">
                </mat-form-field>

                <mat-form-field class="example-full-width">
                    <input matInput [(ngModel)]="guardianDetail.email" name="guardianDetail.email" disabled=true
                        placeholder="Guardian AdLitem Email">
                </mat-form-field>

                <mat-form-field class="example-full-width">
                    <input matInput [(ngModel)]="guardianDetail.phone_number" name="guardianDetail.phone_number" disabled=true
                        placeholder="Guardian AdLitem Phone Number">
                </mat-form-field>

                <button mat-raised-button color="accent" [class.loading]="loading" [disabled]="loading"
                        class="" (click)="close()">OK</button>

                <div *ngFor="let msg of caseForm.message">
                    <span class="textColor">{{ msg }}</span>
                    <br />
                </div>
            </form>
        </div>
    </div>

    <div
        *ngIf="( userRole == 'GUARDIAN') && caseData.summary.current_form == 'THREEFOUR' && caseData.summary.status == 'APPROVED_BY_CLERK'">

        <mat-toolbar>
            <h4>Guardianship Request</h4>
        </mat-toolbar>

        <br />

        <div>
            <b>Address : </b> {{caseData.ward?.address||'----'}}</div>
        <br />
        <div>
            <b>City :</b> {{caseData.ward?.city||'---'}}&nbsp;&nbsp;
            <b> State :</b> {{caseData.ward?.state||'---'}}&nbsp;&nbsp;
            <b> Zip :</b> {{caseData.ward?.zip||'---'}}&nbsp;&nbsp;
        </div>
        <br />
        <div>
            <b> Language : </b> {{caseData.ward?.language || '----'}} &nbsp;&nbsp;
            <b>Alias_Names :</b> {{caseData.ward?.alias_names || '---'}} &nbsp;&nbsp;
        </div>
        <br />

        <div>
            <b>Name : </b> {{caseData.ward?.first_name}} {{caseData.ward?.middle_name}} {{caseData.ward?.last_name}}
            &nbsp;&nbsp;
            <b>Date of Birth :</b> {{caseData.ward?.date_of_birth|date:"dd/MM/yy" || '-----' }} &nbsp;&nbsp;
        </div>
        <br />


        <br />
        <br />
        <p class="heading">People Involved with this case:</p>

        <div class="p-12">


            <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.xs="row" class="people">

                <div *ngFor="let contact of caseContacts;" class="w-50">

                    <div fxLayout="col" fxLayout.xs="column" class="people-left">
                        <img class="avatar" src="assets/images/avatars/profile.jpg">
                        <div class="pt-10p">
                            <mat-hint class="name"> {{contact.name}} </mat-hint>
                            <br />
                            <mat-hint>{{contact.position}}</mat-hint>
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <br />

        <button mat-raised-button [class.loading]="loading" color="accent" class="pull-left"
            (click)="guardianAction(true)" style="width : 125px" [style.textAlign]="!loading ? 'center': 'right'">
            <div class="spinner"></div>
            <span class="label">Accept</span>
        </button>

        <button mat-raised-button [class.loading]="loadingDeny" color="warn" class="pull-right"
            (click)="guardianAction(false)" style="width : 125px" [style.textAlign]="!loadingDeny ? 'center': 'right'">
            <div class="spinner"></div>
            <span class="label">Decline</span>
        </button>


        <br>
        <br>
    </div>

    <div
        *ngIf="( userRole == 'GUARDIAN') && caseData.summary.current_form == 'THREEFIVE' &&  (caseData.summary.status == 'APPROVED_BY_CLERK' ||  caseData.summary.status == 'DENIED_BY_CLERK')">
        <mat-toolbar>
            <h4 class="hearingNotice">Upload Bond 3.5</h4>
        </mat-toolbar>
        <!-- <p style="text-align : center ; font-size : 17px ">
            <strong>Upload Bond 3.5</strong>
          </p> -->

        <button [class.loading]="loading" type="button" mat-raised-button color="accent" (click)="docUpload.click()">
            <div class="spinner"></div>
            <span class="label">Upload Bond</span>
        </button>
        <input hidden type="file" #docUpload (change)="uploadTHREEFIVE($event)" />
    </div>

    <div
        *ngIf="( userRole == 'CLERK' || userRole == 'JUDGE' ) && caseData.summary.current_form == 'THREEFIVE' && caseData.summary.status == 'FILED_FOR_CLERK'">
        <mat-toolbar>
            <h4 class="hearingNotice">Review Bond</h4>
        </mat-toolbar>
        <!-- <p style="text-align : center ; font-size : 17px ">
            <strong>Review Bond</strong>
          </p> -->

        <iframe src="" style="min-height: 585px; min-width:500px; width: 100%; height: 100%" id="first"
            frameborder="1"></iframe>

        <br />
        <br />

        <button [class.loading]="loading" [disabled]="loading" mat-raised-button color="warn"
            (click)="threeFiveDeny(false)" class="pull-left">

            <span class="label">Deny</span>
        </button>

        <button [class.loading]="loading" [disabled]="loading" mat-raised-button color="accent"
            (click)="threeFiveAccept(false)" class="pull-right">
            <div class="spinner"></div>
            <span class="label">Accept</span>
        </button>

        <button></button>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/case-action/case-action.component.html